import { useEffect } from 'react';

const hasLoaded = {};

function loadScript(src) {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.body.appendChild(script);
    return script;
}

const Loaders = {
    googleanalytics: settings => {
        const id = settings?.id;
        if (!id) {
            return;
        }

        loadScript(`https://www.googletagmanager.com/gtag/js?id=${id}`);
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', id);
    },
    googletagmanager: settings => {
        const id = settings?.id;
        if (!id) {
            return;
        }

        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', id);
    },
    metapixel: settings => {
        const id = settings?.id;
        if (!id) {
            return;
        }

        !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod
                    ? n.callMethod.apply(n, arguments)
                    : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(
            window,
            document,
            'script',
            'https://connect.facebook.net/en_US/fbevents.js',
        );
        fbq('init', id);
        fbq('track', 'PageView');
    },
    clarity: settings => {
        const id = settings?.id;
        if (!id) {
            return;
        }

        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", id);
    },
};

const EventTrackingIntegration = ({ integrationSettings }) => {
    // TODO: go through key/values after integrationSettings loads
    //  and inject the code if needed
    //  record whether we injected it
    useEffect(() => {
        if (!integrationSettings) {
            return;
        }

        Object.keys(integrationSettings).forEach(key => {
            if (typeof Loaders[key] === 'function' && !hasLoaded[key]) {
                Loaders[key](integrationSettings[key]);
                hasLoaded[key] = true;
            }
        });
    }, [JSON.stringify(integrationSettings)]);
};

export default EventTrackingIntegration;
